export const getOrderIdent = (prefix: string): string => {
  const code = new Date().getMilliseconds();
  const today = new Date().toLocaleString('en-US', { timeZone: 'UTC' });
  const str = today.replace(/\//g, '');
  const _ident = `${prefix}-${str.split(',')[0]}${code}`;
  return _ident;
}
